(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recent-purchase-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('recent-purchase-popup')) {
    customElements.define('recent-purchase-popup', class extends HTMLElement {
      connectedCallback() {
        if (sessionStorage.getItem('recent-purchase-popup-closed') === 'true') return;

        this.items = [...this.querySelectorAll('[data-purchase]')];
        if (!this.items.length) return;

        this.index = 0;
        this.duration = Number(this.dataset.duration) || 7000;
        this.interval = Number(this.dataset.interval) || 18000;
        this.closeButton = this.querySelector('.recent-purchase-popup__close');
        this.closeButton.addEventListener('click', () => this.close());
        this.timer = window.setTimeout(() => this.show(), Number(this.dataset.delay) || 5000);
      }

      show() {
        const item = this.items[this.index];
        const link = this.querySelector('.recent-purchase-popup__link');
        const image = this.querySelector('.recent-purchase-popup__image');

        this.querySelector('.recent-purchase-popup__product').textContent = item.dataset.product;
        this.querySelector('.recent-purchase-popup__buyer').textContent = item.dataset.buyer;
        this.querySelector('.recent-purchase-popup__location').textContent = item.dataset.location;
        link.href = item.dataset.url || '#';
        image.src = item.dataset.image;
        image.alt = item.dataset.product;
        this.classList.add('is-visible');

        this.hideTimer = window.setTimeout(() => this.hide(), this.duration);
      }

      hide() {
        this.classList.remove('is-visible');
        this.index = (this.index + 1) % this.items.length;
        this.timer = window.setTimeout(() => this.show(), Math.max(this.interval - this.duration, 1000));
      }

      close() {
        window.clearTimeout(this.timer);
        window.clearTimeout(this.hideTimer);
        this.classList.remove('is-visible');
        sessionStorage.setItem('recent-purchase-popup-closed', 'true');
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        window.clearTimeout(this.hideTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
